<template>
  <div class="member">
    <fixed-header class="member__header" title="商城会员权益"></fixed-header>
    <div v-infinite-scroll="getNextVipGoods" :infinite-scroll-disabled="loading"
         :infinite-scroll-distance="30"
         class="member-main scroll-touch">
      <!--会员信息-->
      <div class="member__info">
        <div :class='["member__info-card", "vip-"+vipType]'>
          <div class="member__info-card-user">
            <div class="member__info-card-user-info">
              <p class="member__info-card-user-info-name"><img :src="vipInfo.headPicL"
                                                               class="member__info-card-user-avatar">{{
                  vipInfo.nickname
                }}<span>{{ getVipType() }}</span>
              </p>
              <p v-if="vipType === 2" class="member__info-card-user-info-save" mg-stat-click
                 mg-stat-custom="cont=消费记录&label=btn&direct=cntp" mg-stat-mod="cusrec" @click="openSavePop()"
              >累计已节省<span>¥{{ vipInfo.vipSaveTotalAmount }} ></span></p>
            </div>
            <div class="member__info-card-user-vip">
              <p v-if="vipType === 2">{{ vipInfo.vipEndTime }} 到期</p>
              <p v-if="vipType === 2" mg-stat-click mg-stat-custom="cont=会员购买记录&label=btn&direct=cntp"
                 mg-stat-mod="vipbuyrec"
                 @click="openPurchasePop()">购买记录></p>
              <button :mg-stat-custom="`cont=${memberBtnHtml[vipType]}&label=btn&direct=cntp&addr=haowu_member_pay`"
                      mg-stat-click mg-stat-mod="continue"
                      @click="memberPay()"
              >{{ memberBtnHtml[vipType] }}
              </button>
            </div>
          </div>
        </div>
        <!--            <div class="member__info-avatar">-->
        <!--                <img src="">-->
        <!--            </div>-->
        <!--            <div class="member__info-info">-->
        <!--                <p class="nickname">昵称昵称<span>会员类型</span></p>-->
        <!--                <p class="purchase">2020.07.15到期 <a>购买记录>></a></p>-->
        <!--                <p class="amount">累计已省 ￥270.00>></p>-->
        <!--            </div>-->
        <!--            <div class="member__info-btn">-->
        <!--                <button @click="memberPay()">{{memberBtnHtml}}</button>-->
        <!--            </div>-->
      </div>
      <!--会员权益-->
      <div class="member__benefit">
        <p class="member__benefit-title">商城会员权益</p>
        <div v-if="vipType==2" class="member__benefit-section-normal">
          <div class="member__benefit-section-normal-child">
            <img src="../../assets/img/member/member_cash_icon.png"/>
            <p>专享代金券</p>
          </div>
          <div class="member__benefit-section-normal-child">
            <img src="../../assets/img/member/member_vip_icon.png"/>
            <p>专享会员价</p>
          </div>
          <div class="member__benefit-section-normal-child">
            <img src="../../assets/img/member/member_coupon_icon.png"/>
            <p>会员折扣券</p>
          </div>
          <div class="member__benefit-section-normal-child">
            <img src="../../assets/img/member/member_borthday_icon.png"/>
            <p>生日福利</p>
          </div>
          <div class="member__benefit-section-normal-child">
            <img src="../../assets/img/member/member_seconds_icon.png"/>
            <p>专属秒杀</p>
          </div>
        </div>
        <div v-else class="member__benefit-section">
          <div class="member__benefit-section-child">
            <img src="../../assets/img/member/member_n_icon_1.png"/>
            <p>专享代金券</p>
          </div>
          <div class="member__benefit-section-child">
            <img src="../../assets/img/member/member_n_icon_2.png"/>
            <p>专享会员价</p>
          </div>
          <div class="member__benefit-section-child">
            <img src="../../assets/img/member/member_n_icon_5.png"/>
            <p>会员折扣券</p>
          </div>

          <!--                    <div class="member__benefit-section-child">-->
          <!--                        <img src="../../assets/img/member/member_n_icon_4.png"/>-->
          <!--                        <p>运费券</p>-->
          <!--                    </div>-->
          <!--                    <div class="member__benefit-section-child">-->
          <!--                        <img src="../../assets/img/member/member_n_icon_5.png"/>-->
          <!--                        <p>周边福利</p>-->
          <!--                    </div>-->
          <div class="member__benefit-section-child">
            <img src="../../assets/img/member/member_n_icon_3.png"/>
            <p>生日福利</p>
          </div>
          <div class="member__benefit-section-child">
            <img src="../../assets/img/member/member_n_icon_7.png"/>
            <p>会员专属秒杀</p>
          </div>
        </div>
        <div v-if="counpons && counpons.length" class="member__benefit-coupons ">
          <div class="member__benefit-coupons-wrapper swiper-wrapper">
            <div v-for="(item,index) in counpons" v-bind:key="index"
                 :class='["member__benefit-coupons-wrapper-item", "swiper-slide",item.receiveStatus?"received":""]'
                 :mg-stat-click="vipType===2"
                 :mg-stat-custom="`cont=${item.receiveStatus?'点击优惠券':'立即领取'}&label=btn&direct=cntp${item.receiveStatus===1?(item.useType==0?'&addr=haowu_home':'&addr=haowu_coupon_goods'):''}`"
                 :mg-stat-lob="`${item.receiveStatus===0?'couponid='+item.id:''}`"
                 mg-stat-mod="coupon"
                 @click="getCoupon(item)">
              <p class="type">VIP{{ item.saleType === 1 ? "代金券" : "折扣券" }}</p>
              <p class="cnt">{{ item.saleType === 1 ? '￥' + item.money : getDisCount(item.discount) + '折' }}<span
                  v-if="item.condition">满{{ item.condition }}可用</span></p>
              <p class="cnt comment"> {{ item.useType ? '指定商品可用' : '全店通用' }}
              <p>
              <p class="btn">{{ item.receiveStatus ? "去使用" : "立即领取" }}</p>
            </div>

          </div>
        </div>
      </div>
      <div class="member__bottom">
        <!--会员秒杀-->
        <div v-if="flashgoods && flashgoods.length" class="member__bottom__seckill">
          <img class="tilte-img" src="../../assets/img/member/member_second_kills.png"/>
          <div class="member__bottom__seckill-group">
            <div class="member__bottom__seckill-group-wrapper swiper-wrapper">
              <div v-for="(item,index) in flashgoods" v-bind:key="index"
                   class="member__bottom__seckill-group-wrapper-item swiper-slide">
                <div :mg-stat-custom="`cont=${item.goodsId}&label=goods&direct=cntp&addr=haowu_goods_detail`"
                     :mg-stat-lob="`goodsdc=${goodsdc}`"
                     :style="'background-image:url('+item.originalImg+')'" class="detail"
                     mg-stat-click
                     mg-stat-mod="seckill"
                     @click="goFlashGoodsDetail(item.goodsId,goodsdc)">
                  <div v-if="item.isBegin===0" class="future">{{ item.startTime.substr(5, 5) }}
                    {{ item.flashStartTime.substr(0, 5) }} 开始
                  </div>
                  <div v-if="item.isBegin===1 && item.isEnd === 1" class="end">已结束</div>
                  <div v-if="onFlash(item)" class="on">进行中</div>
                  <div v-if="flashToday(item)" class="countdown">
                    倒计时<span>{{
                      flashTime[index] ? flashTime[index].hour : '00'
                    }}</span>:<span>{{
                      flashTime[index] ? flashTime[index].minute : '00'
                    }}</span>:<span>{{ flashTime[index] ? flashTime[index].second : '00' }}</span>
                  </div>
                </div>
                <p class="goodname">{{ item.goodsName }}</p>
                <p class="goodprice"><span class="desc">秒杀</span><span class="price">{{ item.price }}</span><span
                    class="oldprice">{{ item.shopPrice }}</span></p>
              </div>
            </div>
          </div>
        </div>
        <!--周边福利
        <div class="member__bottom__welfare">
            <p>周边福利</p>
            <div class="member__bottom__welfare-item"></div>
            <div class="member__bottom__welfare-item"></div>
        </div>-->
        <!--会员权益tap-->
        <member-rights :coupons="sortCounpons" :goods="goods" :vipType="vipType"></member-rights>
      </div>
      <mt-popup v-model="showPurchasePop" class="member__popup-purchase">
        <p class="member__popup-purchase-title">购买记录</p>
        <div>
          <table border="0" cellpadding="0" cellspacing="0" class="member__popup-purchase-table">
            <tr class="member__popup-purchase-table-head">
              <td>购买时间</td>
              <td>购买卡种</td>
              <td>有效天数</td>
              <td>状态</td>
            </tr>
            <tr v-for="(item,index) in vipOrderList" v-bind:key="index" class="member__popup-purchase-table-body">
              <td>{{ item.payTime }}</td>
              <td>{{ item.productName }}</td>
              <td>{{ item.productValidDate }}</td>
              <td :class='"status-"+item.vipStatus'>{{ getVipStatus(item.vipStatus) }}</td>
            </tr>
          </table>
        </div>
        <button @click="showPurchasePop=false">知道了</button>
      </mt-popup>
      <mt-popup v-model="showSavePop" class="member__popup-save">
        <div class="member__popup-save-header">
          <div class="member__popup-save-header-tap purchase"><p class="desc">已消费</p>
            <p class="amount">¥{{ vipInfo.vipConsumptionAmount }}</p></div>
          <div class="member__popup-save-header-tap save"><p class="desc">为您节省</p>
            <p class="amount">¥{{ vipInfo.vipSaveTotalAmount }}</p></div>
        </div>
        <ul class="member__popup-save-list">
          <li><span class="desc">专享价节省总额</span><span class="amount">¥{{ vipInfo.savingVipPrice }}</span></li>
          <li><span class="desc">折扣券节省总额</span><span class="amount">¥{{ vipInfo.savingDiscountCoupon }}</span></li>
          <li><span class="desc">代金券节省总额</span><span class="amount">¥{{ vipInfo.savingVoucher }}</span></li>
        </ul>
        <button class="member__popup-save-btn" @click="showSavePop=false">知道了</button>
      </mt-popup>
      <mt-popup v-model="showExpertPop" class="member__popup-export">
        <p class="member__popup-export-title">专享代金券</p>
        <p class="member__popup-export-cnt">芒果TV会员每月可领取5元，10元，15元，20元代金券各1次，可与会员价叠加使用哦！</p>
        <p class="member__popup-export-btn" @click="showExpertPop=false">知道了</p>
      </mt-popup>
    </div>

  </div>
</template>
<script>
import FixedHeader from 'components/common/FixedHeader';
import Swiper from 'Swiper';
import MemberRights from 'components/member/Rights';
import * as VipApi from 'apis/member';
import { getCouponById } from 'apis/coupon';
import { guid } from 'utils';
import MgStat from 'MgStat';
import { judgeLogin } from 'utils/user';

export default {
  components: { FixedHeader, MemberRights },
  data() {
    return {
      showPurchasePop: false,
      showSavePop: false,
      showExpertPop: false,
      vipInfo: {},
      vipType: 0,
      vipdetail: { 0: '普通用户', 1: '视频会员', 2: '商城会员' },
      vipStatus: { 0: '已失效', 1: '生效中', 2: '已完成' },
      memberBtnHtml: { 0: '开通会员', 1: '立即升级', 2: '立即续费' },
      flashgoods: [],
      flashTime: [], // 秒杀剩余时间
      counpons: [],
      sortCounpons: [],
      goodsParam: {
        p: 1, // 页码
        limit: 6, // 页大小
      },
      goodsTotalPage: 0, // 总页数
      goods: [],
      loading: false, // 是否正在加载
      vipOrderList: [],
      interval: null,
      goodsdc: this.guid(),
    };
  },
  computed: {},
  async created() {
    this.judgeLogin(() => {
      // 获取用户信息
      this.getUserInfo();
      // 获取优惠券信息
      this.getCoupons();
      // 获取秒杀商品信息
      this.getSecondkillGoods();
      // 获取会员专属商品
      this.getVipGoods();
    });
  },
  mounted() {

  },
  beforeRouteLeave(to, from, next) {
    const intervals = (this.interval);
    if (intervals) {
      clearInterval(intervals);
    }
    next();
  },
  methods: {
    judgeLogin,
    guid,
    getVipType() {
      return this.vipdetail[this.vipType];
    },
    getVipStatus(status) {
      return this.vipStatus[status];
    },
    async openPurchasePop() {
      MgStat.send('cv', {}, {
        mod: 'c_hwvipbuypop',
      });
      this.vipOrderList = await VipApi.orderlist();
      this.showPurchasePop = true;
    },
    async openSavePop() {
      MgStat.send('cv', {}, {
        mod: 'c_hwcustrecpop',
      });
      this.showSavePop = true;
    },
    async getUserInfo() {
      const vipInfo = await VipApi.userinfo();
      this.vipInfo = vipInfo;
      this.vipType = vipInfo.vipType;
    },
    async getSecondkillGoods() {
      const flashgoodlist = await VipApi.flashgoods();
      this.flashgoods = flashgoodlist.sort((a, b) => {
        // eslint-disable-next-line no-cond-assign
        if (a.isEnd === b.isEnd) {
          return this.timeCompare(b.flashStartTime, a.flashStartTime);
        }
        return a.isEnd - b.isEnd || a.isBegin > b.isBegin;
      });

      this.setFlashTime(this.flashgoods);
      this.$nextTick(() => {
        // eslint-disable-next-line no-new
        new Swiper('.member__bottom__seckill-group', {
          slidesPerView: 3,
        });
      });
    },
    getNumber(num) {
      // eslint-disable-next-line no-nested-ternary
      return num ? (num >= 10 ? num : `0${num}`) : '00';
    },
    setFlashTime(flashgoods) {
      const that = this;
      this.interval = setInterval(() => {
        if (flashgoods && flashgoods.length > 0) {
          let onFlash = false;
          flashgoods.forEach((item, index) => {
            if (that.flashToday(item)) {
              onFlash = true;
              let endTime = 0;
              const d = new Date();
              const startTime = new Date(`${d.getFullYear()}/${d.getMonth() + 1}/${d.getDate()} ${item.flashStartTime}`).getTime();
              if (d.getTime() < startTime) {
                endTime = (startTime / 1000) - (new Date().getTime() / 1000);
              } else {
                // 如果今天已结束 那么倒计时的日期为明天的开始日期
                // eslint-disable-next-line no-mixed-operators
                endTime = (startTime / 1000 + (24 * 60 * 60)) - (new Date().getTime() / 1000);
              }
              that.$set(that.flashTime, index, {
                day: this.getNumber(Math.floor(endTime / 86400)),
                hour: this.getNumber(Math.floor((endTime % 86400) / 3600)),
                minute: this.getNumber(Math.floor((endTime % 3600) / 60)),
                second: this.getNumber(Math.floor((endTime % 3600) % 60)),
              });
            }
          });
          if (!onFlash) {
            clearInterval(this.interval);
          }
        }
      }, 1000);
    },
    async getCoupons() {
      const counponlist = await VipApi.coupons();
      this.counpons = counponlist.concat().sort((a, b) => a.receiveStatus - b.receiveStatus);
      this.sortCounpons = counponlist.sort((a, b) => a.useType - b.useType);
      this.$nextTick(() => {
        // eslint-disable-next-line no-new
        new Swiper('.member__benefit-coupons', {
          slidesPerView: 2,
        });
      });
    },
    getDisCount(discount) {
      // 80 显示 8折  82 显示82折
      return discount % 10 ? discount : discount / 10;
    },
    async getVipGoods() {
      this.loading = true;
      try {
        const vipgoods = await VipApi.goods(this.goodsParam);
        const goodsrecords = vipgoods.records;
        if (goodsrecords && goodsrecords.length > 0) {
          this.goods = [...this.goods, ...goodsrecords];
        }
        this.goodsTotalPage = vipgoods.pages;
      } catch (e) {
        console.log('会员专属商品加载失败', e);
      } finally {
        this.loading = false;
      }
    },
    async getCoupon(item) {
      try {
        const { receiveStatus, id, useType } = item;
        const coupon_id = id;
        if (this.vipType === 2) {
          if (receiveStatus === 0) {
            await getCouponById({ couponId: coupon_id });
            this.$toast('已经领取咯，快去使用吧');
            this.getCoupons();
          } else if (useType) {
            this.$router.push({ path: '/coupon/goods', query: { id: coupon_id, showBack: 1 } });
          } else {
            this.$router.push({ path: '/home' });
          }
        } else {
          this.$toast('您还不是商城会员哦，开通商城会员享更多权益');
        }
      } catch (e) {
        this.$toast(`${e.message}`);
      }
    },
    getNextVipGoods() {
      const page = this.goodsParam.p;
      if (page < this.goodsTotalPage) {
        this.goodsParam.p = page + 1;
        this.getVipGoods();
      }
    },
    // 判断正在倒计时
    flashToday(item) {
      return item.isBegin && !item.isEnd && (this.timeCompare(item.flashStartTime) || !this.timeCompare(item.flashEndTime));
    },
    // 判断正在秒杀
    onFlash(item) {
      return item.isBegin && !item.isEnd && !this.timeCompare(item.flashStartTime) && this.timeCompare(item.flashEndTime);
    },
    // 当前时分秒是否大與于当前时间
    timeCompare(a, d) {
      const date = new Date();
      if (d) {
        d = new Date(`${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()} ${d}`);
      } else {
        d = date;
      }
      return new Date(`${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()} ${a}`).getTime() > d.getTime();
    },
    memberPay() {
      this.$router.push('/member/pay');
    },
    goFlashGoodsDetail(id) {
      if (this.vipType === 2) {
        this.$router.push({ path: '/goods/detail', query: { id, showBack: 1, goodsdc: this.goodsdc } });
      } else {
        this.$toast('您还不是商城会员哦，无法参加活动');
      }
    },
    goGoodsDetail(id) {
      this.$router.push({ path: '/goods/detail', query: { id, showBack: 1 } });
    },

  },

};
</script>
<style lang="scss">
.member__header {
  .fixed-header {
    color: #fff;
    background-color: #282323FF !important;

    section, button {
      padding-top: 0px !important;
    }

    .back-padding-top-new {
      padding-top: 12px !important;
    }

    i.icon.go_back {
      background-image: url('../../assets/img/icon/go_back_white.png');
    }
  }

  .fixed-header__title {
    color: #fff;
  }
}
</style>
<style lang="scss" scoped>
.member {
  height: 100%;
  box-sizing: border-box;

  &__header {
    .fixed-header {
      background-color: unquote('#282323FF');
    }
  }

  &-main {
    background-color: #fff;
    height: 100%;
    overflow-y: scroll;
  }

  &__info {
    height: 228px;
    width: 100%;
    background: url("../../assets/img/member/member_card_bottom_shadow.png") no-repeat unquote('#282323FF');
    background-size: 750px 31px;
    background-position-y: 200px;
    position: relative;

    div {
      float: left;
    }

    .vip-0 {
      background-image: url("../../assets/img/member/member_card_normal.png");
    }

    .vip-1 {
      background-image: url("../../assets/img/member/member_card_video.png");
    }

    .vip-2 {
      background-image: url("../../assets/img/member/member_card_mall.png");
    }

    &-card {
      width: 670px;
      height: 322px;
      margin: 20px 0px 0px 40px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      border-radius: 20px;
      position: relative;

      &-user {
        padding: 40px;

        &-avatar {
          width: 88px;
          height: 88px;
          background: rgba(255, 255, 255, 1);
          border-radius: 50%;
          float: left;
          margin-right: 24px;
        }

        &-info {
          width: 100%;

          &-name {
            font-size: 32px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(82, 55, 17, 1);
            line-height: 45px;
            margin-bottom: 9px;

            span {
              margin-left: 10px;
              padding: 2px 15px;
              font-size: 20px;
              color: rgba(255, 255, 255, 1);
              line-height: 28px;
              width: 100px;
              height: 29px;
              background: rgba(230, 177, 95, 1);
              border-radius: 15px;
            }
          }

          &-save {
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(82, 55, 17, 1);
            line-height: 33px;

            span {
              margin-left: 10px;
              color: #fff;
            }
          }
        }

        &-vip {
          margin-top: 79px;
          width: 100%;

          p {
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(82, 55, 17, 1);
            line-height: 33px;
          }

          button {
            position: absolute;
            right: 31px;
            bottom: 39px;
            width: 200px;
            height: 64px;
            line-height: 64px;
            font-size: 32px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(154, 107, 31, 1);
            background: url("../../assets/img/member/member_card_pay_btn.png") no-repeat;
            background-size: 100% 100%;
          }
        }
      }
    }
  }

  &__benefit {
    margin-top: 150px;

    &-title {
      font-size: 36px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(52, 52, 52, 1);
      line-height: 50px;
      margin-left: 24px;
      margin-bottom: 27px;
    }

    &-section {
      height: 150px;
      padding: 10px 20px;
      display: flex;
      justify-content: space-between;

      &-normal {
        padding: 0px 35px;
        display: flex;
        justify-content: space-between;

        &-child {
          float: left;
          width: 120px;
          text-align: center;

          img {
            height: 102px;
            width: 102px;
          }

          p {
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(85, 85, 85, 1);
            line-height: 33px;
            margin-top: -10px;
          }
        }
      }

      &-child {
        float: left;
        height: 150px;
        text-align: center;

        img {
          width: 90px;
          height: 90px;
        }

        p {
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(85, 85, 85, 1);
        }
      }
    }

    &-coupons {
      padding: 20px 0px 20px 20px;
      height: 130px;
      overflow: hidden;

      &-wrapper {
        &-item {
          width: 321px !important;
          background-image: url("../../assets/img/member/member_coupon_receive.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          height: 146px;
          margin-left: 10px;
          border-radius: 5px;
          color: #fff;
          float: left;
          line-height: 40px;

          .type {
            margin: 10px;
            width: 110px;
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            background-color: #000;
            border-radius: 5px;
            padding: 3px 5px;
            font-weight: 500;
            color: rgba(252, 244, 235, 1);
            line-height: 24px;
            height: 24px;
            text-align: center;
          }

          .cnt {
            text-align: center;
            font-size: 40px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(82, 55, 17, 1);
            line-height: 40px;
            margin-top: 15px;
            text-align: left;
            padding-left: 20px;

            span {
              margin-left: 10px;
              font-size: 22px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(181, 152, 114, 1);
              line-height: 30px;
            }
          }

          .cnt.comment {
            margin-top: 0px;
            font-size: 22px;
          }

          .btn {
            width: 40px;
            height: 100%;
            position: absolute;
            right: 5px;
            top: 0;
            text-align: center;
            font-size: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            line-height: 35px;
          }
        }

        &-item.received {
          background-image: url("../../assets/img/member/member_coupon_received.png");

          .type {
            background-color: rgb(211, 213, 219);
            color: #fff;
          }

          .cnt {
            color: rgba(156, 163, 171, 1);

            span {
              color: rgba(156, 163, 171, 1);
            }
          }

          .cnt.comment {
            color: rgba(186, 192, 198, 1);
          }
        }
      }
    }
  }

  &__bottom {
    margin-top: 40px;
    padding: 20px 24px 40px 24px;
    overflow: hidden;
    background: url("../../assets/img/member/member_flash_kill_bg.png") no-repeat;
    background-size: 100% 100%;

    &__seckill {
      margin-bottom: 20px;

      .tilte-img {
        width: 213px;
        height: 34px;
      }

      &-group {
        &-wrapper {
          height: 100%;
          margin-top: 20px;

          &-item {
            margin-right: 12px;
            width: 220px;

            .detail {
              width: 220px !important;
              height: 260px;
              background-repeat: no-repeat;
              background-size: 100% 100%;
              border-radius: 10px;
              position: relative;

              .on {
                width: 97px;
                height: 40px;
                background: url("../../assets/img/member/member_second_kills_on.png") no-repeat;
                background-size: 100% 100%;
                font-size: 22px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: rgba(255, 255, 255, 1);
                padding-right: 10px;
                line-height: 40px;
                text-align: right;
                position: absolute;
                top: 16px;
                right: 0px;
              }

              .countdown {
                width: 100%;
                background: linear-gradient(135deg, rgba(255, 43, 60, 1) 0%, rgba(255, 95, 79, 1) 100%);
                position: absolute;
                bottom: 0px;
                height: 48px;
                border-bottom-right-radius: 10px;
                border-bottom-left-radius: 10px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-size: 22px;
                font-weight: 500;
                color: rgba(255, 255, 255, 1);
                line-height: 48px;
                text-align: center;

                span {
                  color: rgba(255, 43, 60, 1);
                  width: 27px;
                  height: 30px;
                  border-radius: 5px;
                  background-color: #fff;
                  margin: 0 5px;
                  padding: 0 2px;
                }
              }

              .future {
                text-align: center;
                width: 100%;
                background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 100%);
                position: absolute;
                bottom: 0px;
                height: 48px;
                border-bottom-right-radius: 10px;
                border-bottom-left-radius: 10px;
                font-size: 22px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: rgba(255, 255, 255, 1);
                line-height: 48px;
              }

              .end {
                text-align: center;
                width: 100%;
                background-color: rgba(211, 213, 219, 1);
                position: absolute;
                bottom: 0px;
                height: 48px;
                border-bottom-right-radius: 10px;
                border-bottom-left-radius: 10px;
                font-size: 22px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: rgba(255, 255, 255, 1);
                line-height: 48px;

              }
            }

            .goodname {
              font-size: 28px;
              font-family: PingFangSC-Medium, PingFang SC;
              margin-top: 16px;
              font-weight: 500;
              color: rgba(52, 52, 52, 1);
              line-height: 40px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .goodprice {
              line-height: 28px;
              margin-top: 20px;
              position: relative;

              .desc {
                position: absolute;
                width: 50px;
                text-align: center;
                height: 28px;
                background-color: rgba(255, 43, 60, 1);
                font-size: 18px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: rgba(255, 255, 255, 1);
                border-radius: 4px;
                padding: 0px 2px;
                line-height: 30px;
                bottom: 5px;
              }

              .price {
                font-size: 32px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: rgba(255, 43, 60, 1);
                margin-left: 60px;
              }

              .oldprice {
                font-size: 22px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(136, 136, 136, 1);
                line-height: 30px;
                text-decoration: line-through;
                margin-left: 5px;
              }
            }
          }
        }
      }
    }

    &__welfare {
      width: 100%;

      p {
        font-size: 30px;
        margin-bottom: 20px;
      }

      &-item {
        width: 310px;
        height: 200px;
        border-radius: 10px;
        background-color: #c3c3c3;
        display: inline-block;
      }

      &-item:last-of-type {
        margin-left: 60px;
      }
    }
  }

  &__popup {
    &-save {
      width: 622px;
      height: 597px;
      border-radius: 10px;

      &-header {
        width: 100%;
        padding: 40px 24px 32px 24px;
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;

        &-tap {
          height: 130px;
          width: 282px;
          padding-top: 20px;
          box-sizing: border-box;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          text-align: center;
          color: #fff;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          line-height: 50px;
        }

        .purchase {
          background-image: url("../../assets/img/member/member_popup_purchase_tap.png");
        }

        .save {
          background-image: url("../../assets/img/member/member_popup_save_tap.png");
          color: #000;
        }
      }

      &-list {
        width: 100%;
        overflow: scroll;
        border-bottom: 2px solid rgba(216, 216, 216, 1);

        li {
          display: flex;
          justify-content: space-between;
          padding: 0px 40px;
          line-height: 80px;
          height: 80px;
          color: rgba(0, 0, 0, 1);

          .desc {
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            background: url("../../assets/img/member/member_list_line_circle.png") no-repeat;
            background-size: 16px 16px;
            background-position-y: 32px;
            padding-left: 22px;
          }

          .amount {
            font-size: 28px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
          }
        }
      }

      &-btn {
        width: 440px;
        height: 80px;
        background: linear-gradient(137deg, rgba(241, 211, 158, 1) 0%, rgba(227, 179, 101, 1) 100%);
        border-radius: 50px;
        color: #fff;
        font-size: 28px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
        line-height: 80px;
        text-align: center;
        margin-top: 32px;
        margin-left: 90px;
      }
    }

    &-export {
      width: 582px;
      height: 368px;
      box-sizing: border-box;
      border-radius: 10px;

      &-title {
        font-size: 32px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 1);
        line-height: 45px;
        padding: 33px 40px 16px 40px;
      }

      &-cnt {
        margin-bottom: 64px;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        line-height: 40px;
        padding: 0px 40px;
      }

      &-btn {
        line-height: 88px;
        text-align: center;
        font-size: 32px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(32, 210, 129, 1);
        border-top: solid 2px rgba(216, 216, 216, 1);;
      }
    }

    &-purchase {
      width: 622px;
      height: 627px;
      border-radius: 10px;

      div {
        height: 384px;
        width: 100%;
        overflow: scroll;
        border-bottom: 2px solid rgba(216, 216, 216, 1);
      }

      &-title {
        text-align: center;
        width: 100%;
        height: 99px;
        line-height: 99px;
        font-size: 32px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: blod;
      }

      &-table {
        width: 100%;
        font-family: PingFangSC-Semibold, PingFang SC;
        text-align: center;

        &-head {
          background: url("../../assets/img/member/member_purshase_bk.png") no-repeat;
          background-size: 100% 100%;
          height: 64px;
          padding: 0;
          border-collapse: collapse;
          width: 100%;

          td {
            font-size: 24px;
            font-weight: 600;
            color: rgba(0, 0, 0, 1);
            height: 64px;
            line-height: 32px;
            border: none;
          }
        }

        &-body {
          td {
            height: 64px;
            line-height: 64px;
            font-size: 24px;
            font-weight: 400;
            color: rgba(0, 0, 0, 1);
          }

          td.status-0 {
            color: rgba(136, 136, 136, 1);
          }
        }
      }

      button {
        width: 440px;
        height: 80px;
        background: linear-gradient(137deg, rgba(241, 211, 158, 1) 0%, rgba(227, 179, 101, 1) 100%);
        border-radius: 50px;
        color: #fff;
        font-size: 28px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
        line-height: 80px;
        text-align: center;
        margin-top: 32px;
        margin-left: 90px;
      }
    }

    button {
      margin-top: 20px;
      font-size: 35px;
      height: 60px;
      width: 200px;
      border-radius: 50px;
      line-height: 60px;
      border: solid 1px #000;
    }
  }
}
</style>
